import { PlatformIcon } from "@cntrl/ui";
import { spotifyArtistUrl } from "../../app/vendorLinks.js";
import styles from "./VendorAttribution.module.scss";

/**
 * The attributions our vendors' terms require wherever their data is shown.
 *
 * - GOOGLE PLACES shown without a Google map must carry Google Maps attribution ("the Google Maps logo whenever
 *   possible", the text "Google Maps" otherwise — Places API policies). This is the TEXT form; swap in the official
 *   logo asset (16–19dp tall) when it is added to the brand kit.
 * - SPOTIFY metadata and artwork must be attributed to Spotify with its marks (Spotify Developer Policy).
 */
export function GoogleMapsAttribution() {
  return <span className={styles.google}>Google Maps</span>;
}

export function SpotifyAttribution() {
  return (
    <span className={styles.spotify}>
      <PlatformIcon platform="spotify" size={16} />
      Spotify
    </span>
  );
}

/** The link back to an artist on Spotify that its policy requires wherever a Spotify-sourced act's name or photo
 *  is shown (a lineup chip carries the artwork it picked up). A small mark, opening in a new tab. */
export function SpotifyArtistLink({ spotifyArtistId, name }: { spotifyArtistId: string; name: string }) {
  return (
    <a
      className={styles.spotifyLink}
      href={spotifyArtistUrl(spotifyArtistId)}
      target="_blank"
      rel="noreferrer"
      aria-label={`Open ${name || "this artist"} on Spotify`}
      onClick={(e) => e.stopPropagation()}
    >
      <PlatformIcon platform="spotify" size={16} />
    </a>
  );
}
